import { message } from "antd";
import { useCallback, useMemo } from "react";
import { Button } from "V2.0/common/button";
import {
  Table,
  TableHead,
  TableBody,
  TableHeader,
  TableRow,
  TableCell,
} from "V2.0/common/table";
import { showErrorToast } from "V2.0/utils";
import { deleteKey } from "V2.0/services/keyService";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { TrashIcon } from "@heroicons/react/24/outline";

function getTime(data) {
  if (data === 0) return "Never";

  const epochTime = data;
  const date = new Date(epochTime);
  const dateString = date.toLocaleString(); // or use toUTCString() or toDateString() as needed
  return dateString;
}

export default function APIKeysList(props) {
  const { workspaceId, keys, fetchKeys, isViewOnly } = props;

  const handleDeleteKey = useCallback(
    async function (keyId) {
      const lifecycleCbs = {
        onInit: function () {
          message.loading("Deleting Key");
        },
        onSuccess: function () {
          message.destroy();
          message.success("Key Deleted");
        },
        onError: function (e) {
          message.destroy();
          showErrorToast(e, "Failed to delete key");
        },
      };

      lifecycleCbs.onInit();

      try {
        const response = await deleteKey(workspaceId, keyId);

        if (response.status === 200) {
          lifecycleCbs.onSuccess();
          fetchKeys(workspaceId);
        }
      } catch (e) {
        lifecycleCbs.onError(e);
      }
    },
    [fetchKeys, workspaceId],
  );

  const keysComponent = useMemo(
    function () {
      if (keys.isLoading) {
        return (
          <div className="flex items-center justify-center h-96">
            <AiOutlineLoading3Quarters className="animate-spin" />
          </div>
        );
      }

      if (keys.data.apiKeys.length === 0) {
        return (
          <div className="flex items-center justify-center h-96">
            No API Keys
          </div>
        );
      }

      const tableRowItems = keys.data.apiKeys.map(function (key, idx) {
        const { redactedKey, createdAt, lastUsed, _id } = key;

        return (
          <TableRow key={idx}>
            <TableCell>{redactedKey}</TableCell>
            <TableCell>{getTime(createdAt)}</TableCell>
            <TableCell>{getTime(lastUsed)}</TableCell>
            <TableCell>
              {!isViewOnly && (
                <Button
                  outline
                  onClick={() => handleDeleteKey(_id)}
                >
                  <TrashIcon />
                </Button>
              )}
            </TableCell>
          </TableRow>
        );
      });

      return (
        <Table>
          <TableHead>
            <TableHeader>Key</TableHeader>
            <TableHeader>Created At</TableHeader>
            <TableHeader>Last Used At</TableHeader>
            {!isViewOnly && <TableHeader>Action</TableHeader>}
          </TableHead>
          <TableBody>{tableRowItems}</TableBody>
        </Table>
      );
    },
    [keys, handleDeleteKey],
  );

  return (
    <div className="p-2 flex-1 min-h-0 h-full overflow-scroll">
      {keysComponent}
    </div>
  );
}
